import { render, staticRenderFns } from "./TheQueuesTable.vue?vue&type=template&id=167ab0f2"
import script from "./TheQueuesTable.vue?vue&type=script&lang=js"
export * from "./TheQueuesTable.vue?vue&type=script&lang=js"
import style0 from "./TheQueuesTable.vue?vue&type=style&index=0&id=167ab0f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports